<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'videoCrud'"
            crudName="Videos"
            newText="Novo Video"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :extra="extra"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
            @view-sync="onViewSync"
        >
        </base-crud>
        <video-sync-view ref="videoSyncView"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import VideoSyncView from './ViewSync';

export default {
  data: function () {
    return {
      unidades: [],
      paineis: [],
      table: "videoTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      columns: ["id", "titulo", "descricao", "video", "status", "actions"],
      tableData: ["id", "titulo", "descricao", "video", "caminho", "status"],
      extra: [
        {
          id: 'view-sync',
          name: 'view-sync',
          title: 'Ver Sincronização',
          class: 'btn btn-sm btn-primary btn-sync-view',
          icon: 'fas fa-eye',
          label: ''
        }
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "titulo", "descricao", "video", "status", "sincronizado"],
        pagination: {chunk: 10, dropdown: false, nav: "scroll"},
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          titulo: "Título",
          descricao: "Descrição",
          video: "Vídeo",
          status: "Status",
          sincronizado: "Sincronização",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          unidade_id: [],
          painel_id: [],
          ativo: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ]
        },
        templates: {
          status: function (h, row) {
            const isActive = row.status === true || row.status === 1 || row.status === "true";
            return isActive
                ? h('span', {class: 'badge badge-success'}, 'Ativo')
                : h('span', {class: 'badge badge-secondary'}, 'Inativo');
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return this.$http.get(this.url + "?orderByDesc=id&" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "videos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
    VideoSyncView,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        titulo: "titulo",
        descricao: "descricao",
        video: "video",
        status: "status",
      };

      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

    onViewSync(payload) {
      const id = payload.row.id;
      if (this.$refs.videoSyncView && this.$refs.videoSyncView.open) {
        this.$refs.videoSyncView.open(id);
      }
    },

    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades";

      axios
          .get(api)
          .then((response) => {
            response.data.data.forEach(unidade => {
              self.unidades.push({id: unidade.id, text: unidade.nome});
            });

            self.options.listColumns.unit_id = self.unidades;
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
    },

    getPaineis: function () {
      const self = this;
      const api = self.$store.state.api + "paineis";

      axios
          .get(api)
          .then((response) => {
            response.data.data.forEach(painel => {
              self.paineis.push({id: painel.id, text: painel.nome});
            });

            self.options.listColumns.painel_id = self.paineis;
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
    },
  },

  mounted: function () {
    const self = this;
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>

<style>
.btn-sync-view {
  min-width: 25px !important;
  max-width: 25px !important;
  width: 25px !important;
  min-height: 25px !important;
  max-height: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 11px !important;
  line-height: 1 !important;
  border-radius: 4px !important;
}

.btn-sync-view i {
  margin: 0 !important;
}
</style>

<style scoped>

.video-preview-container {
  max-width: 220px;
}

.video-filename {
  color: #2c3e50;
  font-size: 13px;
  display: block;
  margin-bottom: 8px;
  word-break: break-word;
}

.video-preview video {
  max-width: 100%;
  height: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.no-video {
  min-width: 200px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.no-video i {
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .video-preview-container {
    max-width: 150px;
  }

  .video-preview video {
    width: 150px;
    height: 90px;
  }

  .no-video {
    min-width: 150px;
    min-height: 90px;
  }
}
</style>
